<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="queryData">
          <a-row :gutter="24">
            <a-col :span="24">
              <label class="title">调查员考核表总览</label>
              <label style="margin-left: 20px">考核日期：</label>
              <a-range-picker @change="onChange" v-model="dateRange" />
              <!-- <year-month-picker v-model="selectedMonth" @change="onChange" /> -->
              <a-button style="margin-left: 20px" @click="queryData" type="primary" icon="search">查询</a-button>
              <a-button @click="buildData" type="primary" icon="plus" style="margin-left: 8px" v-has="'assess:build:data'">生成考核数据</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"

          size="middle"
          rowKey="resultid"
          :columns="columns"
          :dataSource="dataSource"
          :scroll="{x:`${width}`,y:'calc(100vh - 350px)'}"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange">
          <!-- <span slot="baselineRepRate">
            基线应答率
            <a-tooltip class="info-row" >
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </span>
          <span slot="periodNum">
            随访完成量
            <a-tooltip class="info-row" >
              <template slot="title">
                动态随访完成量：本月该调查员提交的随访人数/本月系统随机分配给该调查员的随访人数（%）
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </span> -->
        </a-table>
      </div>
      <div>
        <a-modal
          :visible="detailDataVisible"
          title="考核详细信息"
          :footer="null"
          @cancel="detailDataVisible = false"
          width="600px"
          @ok="detailDataVisible = false"          
          cancelText="关闭"
        >
          <div :level="5" style="margin-bottom: 16px;">
            {{ detailData.title }}
          </div>
          <a-descriptions :column="{ xs: 1, sm: 2 }" size="middle" bordered>
            <a-descriptions-item label="调查员姓名">
              {{ detailData.realName || '-' }}
            </a-descriptions-item>
            <a-descriptions-item label="开始时间">
              {{ detailData.startDate }}
            </a-descriptions-item>
            <a-descriptions-item label="结束时间">
              {{ detailData.endDate }}
            </a-descriptions-item>
            <template v-if="detailData.type=='rate1'">
              <a-descriptions-item label="数据项总数">
                {{ detailData.rate1Total || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="准确数量">
                {{ detailData.rate1RightCount || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="修改记录数量">
                {{ detailData.rate1ErrorCount || 0 }}
              </a-descriptions-item>
            </template>
            <template v-if="detailData.type=='rate2'">
              <a-descriptions-item label="计划完成周期数量">
                {{ detailData.rate2Total || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="已完成周期数量">
                {{ detailData.rate2ComplateCount || 0 }}
              </a-descriptions-item>              
            </template>
            <template v-if="detailData.type=='rate3'">
              <a-descriptions-item label="服务总次数">
                {{ detailData.rate3Total || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="投诉次数">
                {{ detailData.rate3QuestionCount || 0 }}
              </a-descriptions-item>
            </template>
            <template v-if="detailData.type=='rate4'">
              <a-descriptions-item label="注册人数">
                {{ detailData.rate4Register || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="未筛选人数">
                {{ detailData.rate4Nofiltrate || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="通过筛选人数">
                {{ detailData.rate4Isfiltrate || 0 }}
              </a-descriptions-item>
              <a-descriptions-item label="不符合纳排人数">
                {{ detailData.rate4Filtratefailinex || 0 }}
              </a-descriptions-item>
            </template>
            <template v-if="detailData.type=='rate5'">
              <a-descriptions-item label="准确度">
                {{ detailData.rate5RightRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="完整度">
                {{ detailData.rate5WholeRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="时效性">
                {{ detailData.rate5TimeRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="失访率">
                {{ detailData.rate5LoseRate || '-' }}
              </a-descriptions-item>
            </template>
            <template v-if="detailData.type=='rate6'">
              <a-descriptions-item label="准确度">
                {{ detailData.rate6RightRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="完整度">
                {{ detailData.rate6WholeRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="时效性">
                {{ detailData.rate6TimeRate || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="失访率">
                {{ detailData.rate6LoseRate || '-' }}
              </a-descriptions-item>
            </template>            
          </a-descriptions>
          <template v-if="detailData.type=='rate7'">              
              <a-table                  
                  :dataSource="detailData.rate7DetailList"
                  :columns="detailColumns"
                  :pagination="false"
                  size="small"
                  rowKey="item"/>
            </template>
        </a-modal>
      </div>
    </a-card>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { getAction,postAction} from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import YearMonthPicker from '@/components/jeecg/YearMonthPicker'
  import Vue from 'vue'
  import dayjs from 'dayjs';
  export default {
    name: 'AssessData',
    components: { YearMonthPicker },
    mixins: [JeecgListMixin],
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        selectedMonth: '',
        dateRange : [],
        width: 100,
        disableMixinCreated:true,
        columns: [
          {
            title: '调查员',
            align:"center",
            width: 100,
            dataIndex: 'realName'
          },
          {
            title: '考核日期',
            align:"center",
            width: 120,
            dataIndex: 'assessDate'
          },
          {
            title: '数据准确率',
            align:"center",
            width: 100,
            dataIndex: 'rate1',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate1')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },            
          },
          {
            title: '随访完成率',
            width: 100,
            align:"center",
            dataIndex: 'rate2',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate2')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '投诉率',
            align:"center",
            width: 100,
            dataIndex: 'rate3',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate3')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '入组率',
            align:"center",
            width: 100,
            dataIndex: 'rate4',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate4')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '基线质控率',
            align:"center",
            width: 100,
            dataIndex: 'rate5',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate5')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '随访质控率',
            align:"center",
            width: 100,
            dataIndex: 'rate6',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate6')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '样本采集缺失率',
            align:"center",
            width: 100,
            dataIndex: 'rate7',
            customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },
                  on: {
                    click: () => this.handleRateClick(text, record, 'rate7')
                  }
                },
                this.formatToPercentWithSymbol(text),
              );
            },
          },
          {
            title: '总体考核率',
            align:"center",
            width: 100,
            dataIndex: 'totalRate',
            customRender: ( text ) => this.formatToPercentWithSymbol(text)
          }         
        ],
        url: {
          list: "/project/projectAssess/list",
        },
        detailDataVisible: false,
        detailData:{},
        detailColumns: [
          { title: '考核指标', dataIndex: 'loseName',  },
          { title: '主观缺失率', dataIndex: 'lose1Rate',  align: 'center' ,customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },                  
                },
                this.formatToPercentWithSymbol(text),
              );
            },},
          { title: '客观缺失率', dataIndex: 'lose2Rate', align: 'center' ,customRender: (text, record, index) => {
              return this.$createElement(
                'span',
                {
                  style: { cursor: 'pointer', color: '#1890ff' },                  
                },
                this.formatToPercentWithSymbol(text),
              );
            },}
        ],
      }
    },
    computed: {
      
    },
    mounted(){
      this.queryParam.projectId = this.projectId
      // this.selectedMonth = this.getCurrentYearMonth()
      // this.queryParam.assessDate = this.selectedMonth   
    },
    watch:{
    },
    methods:{
      // onChange(dateString){
      //   this.ipagination.pageSize = 500;
      //   this.selectedMonth = dateString
      //   console.log('选中的月份:', dateString) // 例如：'2026-01'
      //   this.queryParam.assessDate = dateString
      //   this.loadData(1)
      // },
      loadDataErrorCallback(){
        this.dataSource = []
        this.ipagination.total = 0
      },
      onChange(date, dateString){
        // console.log("--changeDate---",date, dateString)
        // this.ipagination.pageSize = 20;
        this.queryParam.startDate=dateString[0]
        this.queryParam.endDate=dateString[1]
        this.loadData(1)
      },
      formatToPercentWithSymbol(value, fixed = 2) {
        const num = parseFloat(value);
        if (isNaN(num)) return '-';
        return `${(num * 100).toFixed(fixed)}%`;
      },
      getCurrentYearMonth() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
      },
      queryData(){
        console.log('queryData')
        // if(!this.queryParam.startDate  || !this.queryParam.endDate){
        //   this.$message.warning('请选择考核日期范围!')
        //   return
        // }
        // this.ipagination.pageSize = 20;
        this.queryParam.projectId = this.projectId
        // this.queryParam.assessDate = this.selectedMonth
        this.loadData(1)
      },
      handleRateClick(text, record, type){
        console.log(text, record, type)
        //todo 展示不同统计率的数据详情

      },
      handleRateClick(text, record, type){
        this.detailData = {}
        console.log(text, record, type)
        this.detailDataVisible = true;
        //todo 展示不同统计率的数据详情
        this.detailData.realName = record.realName;
        this.detailData.type = type;
        this.detailData.startDate = record.startDate;
        this.detailData.endDate = record.endDate;
        this.detailData.title = "";
        if(type == 'rate1'){
          this.detailData.title = "数据准确率";
          const jsonObj = JSON.parse(record.rate1Detail);
          this.detailData.rate1Total = jsonObj.total;
          this.detailData.rate1RightCount = jsonObj.rightCount;
          this.detailData.rate1ErrorCount = jsonObj.errorCount;          
        }else if(type == 'rate2'){
          this.detailData.title = "随访完成率";
          const jsonObj = JSON.parse(record.rate2Detail);
          this.detailData.rate2Total = jsonObj.total;
          this.detailData.rate2ComplateCount = jsonObj.complateCount;          
        }else if(type == 'rate3'){
          this.detailData.title = "投诉率";
          const jsonObj = JSON.parse(record.rate3Detail);
          this.detailData.rate3Total = jsonObj.total;//服务总次数
          this.detailData.rate3QuestionCount = jsonObj.questionCount;//投诉次数          
        }else if(type == 'rate4'){
          this.detailData.title = "入组率";
          const jsonObj = JSON.parse(record.rate4Detail);
          this.detailData.rate4Register = jsonObj.register;//注册人数
          this.detailData.rate4Nofiltrate = jsonObj.nofiltrate;//未筛选人数
          this.detailData.rate4Isfiltrate = jsonObj.isfiltrate;//通过筛选人数
          this.detailData.rate4Filtratefailinex = jsonObj.filtratefailinex;//不符合纳排          
        }else if(type == 'rate5'){
          this.detailData.title = "基线质控率";
          const jsonObj = JSON.parse(record.rate5Detail);
          this.detailData.rate5RightRate = jsonObj.rightRate;//准确度
          this.detailData.rate5WholeRate = jsonObj.wholeRate;//完整度
          this.detailData.rate5TimeRate = jsonObj.timeRate;//时效性
          this.detailData.rate5LoseRate = jsonObj.loseRate;//失访率          
        }else if(type == 'rate6'){
          this.detailData.title = "随访质控率";
          const jsonObj = JSON.parse(record.rate6Detail);
          this.detailData.rate6RightRate = jsonObj.rightRate;//准确度
          this.detailData.rate6WholeRate = jsonObj.wholeRate;//完整度
          this.detailData.rate6TimeRate = jsonObj.timeRate;//时效性
          this.detailData.rate6LoseRate = jsonObj.loseRate;//失访率          
        }else if(type == 'rate7'){
          this.detailData.title = "样本缺失率";
          const jsonArray = JSON.parse(record.rate7Detail || '[]');
          this.detailData.rate7DetailList = Array.isArray(jsonArray) ? jsonArray : [];          
        }

      },
      buildData(){        
        if(!this.queryParam.startDate  || !this.queryParam.endDate){
          this.$message.warning('请选择考核日期范围!')
          return
        }
        this.$confirm({
          title: '生成考核数据',
          content: (<div>
            <p>确定要生成考核数据吗？当前日期范围原来的考核数据将被覆盖！</p>
          </div>),
          centered: false,
          onOk: () => {
            getAction('/project/projectAssess/build/data',{projectId:this.projectId,startDate:this.queryParam.startDate,endDate:this.queryParam.endDate}).then(res=>{
              if(res.success){
                this.$message.success(res.result)
              }else{
                this.$message.error(res.message)
              }
            }).catch(err=>{
              this.$message.error('生成数据失败')
            })
          }
        })        
      },
      
      disabledDate(current) {        
        const maxDays = 30;
        if (!current) return false;

        //  禁止选择今天之前的日期
        // 如果不需要限制过去时间，可删除此行
        // if (current < dayjs().startOf('day')) return true;
        
        if (!this.dateRange || this.dateRange.length === 0) {
          return false;
        }

        console.log("this.dateRange:"+this.dateRange);

        const [start, end] = this.dateRange;

        // 场景 A：已选开始时间 (start)，正在选结束时间
        // 此时 end 为 null/undefined
        if (start && !end) {
          const startDate = dayjs(start);
          // 计算允许的最大结束日期 = 开始日期 + maxDays
          const maxAllowedDate = startDate.add(maxDays, 'day');
          
          // 如果当前日期 > 最大允许日期，则禁用
          return current > maxAllowedDate;
        }

        // 场景 B：已选结束时间 (end)，正在选开始时间 (取决于用户点击顺序)
        // 为了体验更好，通常也限制开始时间不能太早
        if (end && !start) {
          const endDate = dayjs(end);
          // 计算允许的最小开始日期 = 结束日期 - maxDays
          const minAllowedDate = endDate.subtract(maxDays, 'day');
          
          // 如果当前日期 < 最小允许日期，则禁用
          return current < minAllowedDate;
        }

        return false;
      },
    }
  }
</script>

<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>